import { i18n } from 'src/i18n';
import AuthCurrentTenant from 'src/modules/auth/authCurrentTenant';
import { AuthPlan } from 'src/modules/auth/authPlan';
import { AuthPlanCouponCode } from 'src/modules/auth/authPlanCouponCode';
import selectors from 'src/modules/auth/authSelectors';
import service from 'src/modules/auth/authService';
import { AuthToken } from 'src/modules/auth/authToken';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';
import UsageLogService from 'src/modules/usageLog/usageLogService';
import usageLogTypes from 'src/modules/usageLog/usageLogTypes';
import Message from 'src/view/shared/message';
import Permissions from 'src/security/permissions';
import getStore from 'src/modules/store';
import PermissionChecker from 'src/modules/auth/permissionChecker';


const prefix = 'AUTH';

const authActions = {
  ERROR_MESSAGE_CLEARED: `${prefix}_ERROR_MESSAGE_CLEARED`,

  AUTH_INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  AUTH_INIT_ERROR: `${prefix}_INIT_ERROR`,

  AUTH_START: `${prefix}_START`,
  AUTH_SUCCESS: `${prefix}_SUCCESS`,
  AUTH_ERROR: `${prefix}_ERROR`,

  UPDATE_PROFILE_START: `${prefix}_UPDATE_PROFILE_START`,
  UPDATE_PROFILE_SUCCESS: `${prefix}_UPDATE_PROFILE_SUCCESS`,
  UPDATE_PROFILE_ERROR: `${prefix}_UPDATE_PROFILE_ERROR`,

  PASSWORD_CHANGE_START: `${prefix}_PASSWORD_CHANGE_START`,
  PASSWORD_CHANGE_SUCCESS: `${prefix}_PASSWORD_CHANGE_SUCCESS`,
  PASSWORD_CHANGE_ERROR: `${prefix}_PASSWORD_CHANGE_ERROR`,

  CURRENT_USER_REFRESH_START: `${prefix}_CURRENT_USER_REFRESH_START`,
  CURRENT_USER_REFRESH_SUCCESS: `${prefix}_CURRENT_USER_REFRESH_SUCCESS`,
  CURRENT_USER_REFRESH_ERROR: `${prefix}_CURRENT_USER_REFRESH_ERROR`,

  PASSWORD_RESET_EMAIL_START: `${prefix}_PASSWORD_RESET_EMAIL_START`,
  PASSWORD_RESET_EMAIL_SUCCESS: `${prefix}_PASSWORD_RESET_EMAIL_SUCCESS`,
  PASSWORD_RESET_EMAIL_ERROR: `${prefix}_PASSWORD_RESET_EMAIL_ERROR`,

  PASSWORD_RESET_START: `${prefix}_PASSWORD_RESET_START`,
  PASSWORD_RESET_SUCCESS: `${prefix}_PASSWORD_RESET_SUCCESS`,
  PASSWORD_RESET_ERROR: `${prefix}_PASSWORD_RESET_ERROR`,

  DELETE_ACCOUNT_START: `${prefix}_DELETE_ACCOUNT_START`,
  DELETE_ACCOUNT_SUCCESS: `${prefix}_DELETE_ACCOUNT_SUCCESS`,
  DELETE_ACCOUNT_ERROR: `${prefix}_DELETE_ACCOUNT_ERROR`,

  EMAIL_VERIFY_START: `${prefix}_EMAIL_VERIFY_START`,
  EMAIL_VERIFY_SUCCESS: `${prefix}_EMAIL_VERIFY_SUCCESS`,
  EMAIL_VERIFY_ERROR: `${prefix}_EMAIL_VERIFY_ERROR`,

  EMAIL_CONFIRMATION_START: `${prefix}_EMAIL_CONFIRMATION_START`,
  EMAIL_CONFIRMATION_SUCCESS: `${prefix}_EMAIL_CONFIRMATION_SUCCESS`,
  EMAIL_CONFIRMATION_ERROR: `${prefix}_EMAIL_CONFIRMATION_ERROR`,

  doClearErrorMessage() {
    return {
      type: authActions.ERROR_MESSAGE_CLEARED,
    };
  },

  doSendEmailConfirmation:
    () => async (dispatch, getState) => {
      try {
        dispatch({
          type: authActions.EMAIL_CONFIRMATION_START,
        });
        await service.sendEmailVerification();
        Message.success(
          i18n('auth.verificationEmailSuccess'),
        );
        dispatch({
          type: authActions.EMAIL_CONFIRMATION_SUCCESS,
        });
      } catch (error) {
        Errors.handle(error);
        dispatch({
          type: authActions.EMAIL_CONFIRMATION_ERROR,
        });
      }
    },

  doSendPasswordResetEmail: (email) => async (dispatch) => {
    try {
      dispatch({
        type: authActions.PASSWORD_RESET_EMAIL_START,
      });
      await service.sendPasswordResetEmail(email);
      Message.success(
        i18n('auth.passwordResetEmailSuccess'),
      );
      dispatch({
        type: authActions.PASSWORD_RESET_EMAIL_SUCCESS,
      });
    } catch (error) {
      Errors.handle(error);
      dispatch({
        type: authActions.PASSWORD_RESET_EMAIL_ERROR,
      });
    }
  },

  doRegisterEmailAndPassword:
    (data) => async (dispatch) => {
      try {
        dispatch({ type: authActions.AUTH_START });

        // const token =
        //   await service.registerWithEmailAndPassword(data);
        const token =  data.token
      
        // AuthPlan.set(data.entitlementSlug);
        // AuthPlanCouponCode.set(data.couponCode);

        AuthToken.set(token, true);

        const currentUser = await service.fetchMe();
        AF('pba', 'event',{"eventType":"EVENT","eventValue":{"af_registration_method":`email`,"af_date_a": new Date(),"af_customer_user_id":currentUser?._id},"eventName":"af_complete_registration"})
        // @ts-ignore
        window.fbq('track', 'CompleteRegistration', {
          em: data.email,
          fn: data.firstName,
          ln: data.lastName,
        });

        try {
          await UsageLogService.create({
            localTimestamp: new Date(),
            type: usageLogTypes.APPLICATION_OPEN,
            device: 'WEB',
            soundTitle: null,
            sound: null,
            affirmation: null,
            affirmationProgram: null,
            payload: null,
          });
        } catch (error) {
          console.error(error);
        }

        dispatch({
          type: authActions.AUTH_SUCCESS,
          payload: {
            currentUser,
          },
        });
      } catch (error) {
        await service.signout();

        if (Errors.errorCode(error) !== 400) {
          Errors.handle(error);
        }

        dispatch({
          type: authActions.AUTH_ERROR,
          payload: Errors.selectMessage(error),
        });
      }
    },

  doSigninWithEmailAndPassword:
    (email, password, rememberMe, redirectTo?) =>
    async (dispatch) => {
      try {
        dispatch({ type: authActions.AUTH_START });

        let currentUser = null;

        const token =
          await service.signinWithEmailAndPassword(
            email,
            password,
          );

        AuthToken.set(token, rememberMe);
        currentUser = await service.fetchMe();
        try {
          await UsageLogService.create({
            localTimestamp: new Date(),
            type: usageLogTypes.APPLICATION_OPEN,
            device: 'WEB',
            soundTitle: null,
            sound: null,
            affirmation: null,
            affirmationProgram: null,
            payload: null,
          });
        } catch (error) {
          console.error(error);
        }

        await dispatch({
          type: authActions.AUTH_SUCCESS,
          payload: {
            currentUser,
          },
        });
        AF('pba', 'setCustomerUserId', currentUser?.email);
        AF('pba', 'event',{"eventType":"EVENT","eventName":"af_login","eventValue":{"af_customer_user_id":`Af${currentUser?._id}`,"af_param_2":currentUser?.loginCount}})
        const avoidRedirectPaths = [
          '/settings/password-change',
        ];
        if (
          redirectTo &&
          !avoidRedirectPaths.includes(redirectTo)
        ) {
          getHistory().push(redirectTo);
        }
      } catch (error) {
        await service.signout();

        // Handle 404 (email not found) and 400 (bad request) similarly - show error message only
        if (Errors.errorCode(error) !== 400 && Errors.errorCode(error) !== 404) {
          Errors.handle(error);
        }

        // Customize error message for 404 (email not found)
        let errorMessage = Errors.selectMessage(error);
        if (Errors.errorCode(error) === 404) {
          errorMessage = i18n('auth.signin.emailNotFound') || 'Email or password is incorrect';
        }

        dispatch({
          type: authActions.AUTH_ERROR,
          payload: errorMessage,
        });
      }
    },

  doSignout: () => async (dispatch) => {
    try {
      dispatch({ type: authActions.AUTH_START });
      await service.signout();

      dispatch({
        type: authActions.AUTH_SUCCESS,
        payload: {
          currentUser: null,
        },
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: authActions.AUTH_ERROR,
      });
    }
  },

  doInit: () => async (dispatch) => {
    try {
      const token = AuthToken.get();
      let currentUser = null;

      if (token) {
        currentUser = await service.fetchMe();

        try {
          await UsageLogService.create({
            localTimestamp: new Date(),
            type: usageLogTypes.APPLICATION_OPEN,
            device: 'WEB',
            soundTitle: null,
            sound: null,
            affirmation: null,
            affirmationProgram: null,
            payload: null,
          });
        } catch (error) {
          console.error(error);
        }
      }

      dispatch({
        type: authActions.AUTH_INIT_SUCCESS,
        payload: {
          currentUser,
        },
      });
    } catch (error) {
      service.signout();
      Errors.handle(error);

      dispatch({
        type: authActions.AUTH_INIT_ERROR,
        payload: error,
      });
    }
  },

  doRefreshCurrentUser: () => async (dispatch) => {
    try {
      dispatch({
        type: authActions.CURRENT_USER_REFRESH_START,
      });

      let currentUser = null;
      const token = AuthToken.get();

      if (token) {
        currentUser = await service.fetchMe();
      }

      dispatch({
        type: authActions.CURRENT_USER_REFRESH_SUCCESS,
        payload: {
          currentUser,
        },
      });
    } catch (error) {
      service.signout();
      Errors.handle(error);

      dispatch({
        type: authActions.CURRENT_USER_REFRESH_ERROR,
        payload: error,
      });
    }
  },

  doUpdateProfile: (data) => async (dispatch) => {
    try {
      dispatch({
        type: authActions.UPDATE_PROFILE_START,
      });

      await service.updateProfile(data);

      dispatch({
        type: authActions.UPDATE_PROFILE_SUCCESS,
      });
      await dispatch(authActions.doRefreshCurrentUser());
      Message.success(i18n('auth.profile.success'));
      getHistory().push('/settings');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: authActions.UPDATE_PROFILE_ERROR,
      });
    }
  },

  doChangePassword:
    (oldPassword, newPassword) => async (dispatch) => {
      try {
        dispatch({
          type: authActions.PASSWORD_CHANGE_START,
        });

        await service.changePassword(
          oldPassword,
          newPassword,
        );

        dispatch({
          type: authActions.PASSWORD_CHANGE_SUCCESS,
        });
        await dispatch(authActions.doRefreshCurrentUser());
        Message.success(
          i18n('auth.passwordChange.success'),
        );
        getHistory().push('/');
      } catch (error) {
        Errors.handle(error);

        dispatch({
          type: authActions.PASSWORD_CHANGE_ERROR,
        });
      }
    },

  doVerifyEmail: (token) => async (dispatch, getState) => {
    try {
      const isLoading = selectors.selectLoadingVerifyEmail(
        getState(),
      );

      if (isLoading) {
        return;
      }

      dispatch({
        type: authActions.EMAIL_VERIFY_START,
      });

      await service.verifyEmail(token);

      await dispatch(authActions.doRefreshCurrentUser());

      dispatch({
        type: authActions.EMAIL_VERIFY_SUCCESS,
      });

      const currentUser = getStore().getState().auth.currentUser;
      const currentTenant= getStore().getState().auth.currentTenant;
      const premissionChecker = new PermissionChecker(currentTenant, currentUser);
      if(premissionChecker.isSubscribed){
              getHistory().push('/');
      }else{
        let isPartner = localStorage.getItem("isPartner")?JSON.parse(localStorage.getItem("isPartner")):undefined;
        let partnerRoute = localStorage.getItem("provider");
  if(isPartner){
    getHistory().push(`/auth/subscription/${partnerRoute}`);
  }else {
    getHistory().push('/auth/subscription');
  }
      }

  
    } catch (error) {
      dispatch({
        type: authActions.EMAIL_VERIFY_ERROR,
        payload: Errors.selectMessage(error),
      });
    }
  },

  doResetPassword:
    (token, password) => async (dispatch) => {
      try {
        dispatch({
          type: authActions.PASSWORD_RESET_START,
        });

        await service.passwordReset(token, password);

        Message.success(i18n('auth.passwordResetSuccess'));
        dispatch({
          type: authActions.PASSWORD_RESET_SUCCESS,
        });
        getHistory().push('/');
      } catch (error) {
        Errors.handle(error);

        dispatch({
          type: authActions.PASSWORD_RESET_ERROR,
        });

        dispatch(authActions.doSignout());
        getHistory().push('/');
      }
    },

  doSelectTenant: (tenant) => async (dispatch) => {
    AuthCurrentTenant.set(tenant);
    await dispatch(authActions.doRefreshCurrentUser());
    getHistory().push('/');
  },

  doDeleteAccount: () => async (dispatch) => {
    try {
      dispatch({ type: authActions.DELETE_ACCOUNT_START });
      await service.deleteAccount();
      dispatch({
        type: authActions.DELETE_ACCOUNT_SUCCESS,
      });
      await dispatch(authActions.doSignout());
      getHistory().push('/auth/signin');
    } catch (error) {
      Errors.handle(error);
      dispatch({
        type: authActions.DELETE_ACCOUNT_ERROR,
        payload: Errors.selectMessage(error),
      });
    }
  },
};

export default authActions;
